import { render } from "./LazyImg.vue?vue&type=template&id=68b206f7&scoped=true"
import script from "./LazyImg.vue?vue&type=script&lang=js"
export * from "./LazyImg.vue?vue&type=script&lang=js"

import "./LazyImg.vue?vue&type=style&index=0&id=68b206f7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b206f7"]])

export default __exports__